(() => {
  const boundRegions = new WeakSet();
  const updateControls = region => {
    const detail = region.closest('[data-aw-pdp-detail]');
    if (!detail) return;
    const buttons = Array.from(detail.querySelectorAll('[data-aw-pdp-scroll]'))
      .filter(button => button.dataset.awPdpScrollTarget === region.id);
    const maxScroll = Math.max(0, region.scrollWidth - region.clientWidth);
    buttons.forEach(button => {
      button.disabled = Number(button.dataset.awPdpScroll) < 0
        ? region.scrollLeft <= 1
        : region.scrollLeft >= maxScroll - 1;
      button.closest('.aw-pdp-scroll-controls').hidden = maxScroll <= 1;
    });
  };
  const resizeObserver = typeof ResizeObserver === 'function'
    ? new ResizeObserver(entries => entries.forEach(entry => updateControls(entry.target)))
    : null;
  const initialize = () => {
    document.querySelectorAll('[data-aw-pdp-detail] [data-aw-pdp-scroll]').forEach(button => {
      const detail = button.closest('[data-aw-pdp-detail]');
      const region = detail.querySelector(`#${button.dataset.awPdpScrollTarget}`);
      if (!region) return;
      if (!boundRegions.has(region)) {
        boundRegions.add(region);
        region.addEventListener('scroll', () => updateControls(region), { passive: true });
        resizeObserver?.observe(region);
      }
      updateControls(region);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
  window.addEventListener('resize', initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-aw-pdp-scroll]');
    if (!button || button.disabled) return;
    const detail = button.closest('[data-aw-pdp-detail]');
    const region = detail?.querySelector(`#${button.dataset.awPdpScrollTarget}`);
    if (!region) return;
    region.scrollBy({
      left: Number(button.dataset.awPdpScroll) * Math.max(region.clientWidth * 0.85, 280),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });
})();
